import { useTranslation } from 'react-i18next'

interface ChannelEditorHeaderProps {
  channelId: string
  channelName: string
  isMaster: boolean
  overrideCount: number
}

export function ChannelEditorHeader({
  channelId, channelName, isMaster, overrideCount,
}: ChannelEditorHeaderProps) {
  const { t } = useTranslation()

  return (
    <div className="flex items-center px-5 py-2.5 border-b border-neutral-200 dark:border-neutral-800 bg-neutral-50 dark:bg-neutral-900/30 flex-shrink-0">
      <div className="flex items-center gap-2">
        {isMaster ? (
          <>
            <div className="w-5 h-5 rounded bg-primary-600/20 flex items-center justify-center">
              <svg className="w-3 h-3 text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0h4" />
              </svg>
            </div>
            <span className="text-sm font-semibold text-neutral-900 dark:text-neutral-100">
              {t('productContent.channels.masterLabel')} · {channelName}
            </span>
            <span className="text-2xs px-1.5 py-0.5 rounded bg-primary-100 dark:bg-primary-900/40 text-primary-600 dark:text-primary-400 border border-primary-200 dark:border-primary-800/50 font-medium">DE</span>
            <span className="text-2xs text-neutral-600 ml-2">{t('productContent.channels.masterHint')}</span>
          </>
        ) : (
          <>
            <span className="text-sm font-semibold text-neutral-900 dark:text-neutral-100">{channelName}</span>
            <span className="text-2xs font-mono px-1.5 py-0.5 rounded bg-neutral-100 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 border border-neutral-200 dark:border-neutral-700">
              {channelId}
            </span>
            {overrideCount > 0 && (
              <span className="text-2xs text-primary-400 ml-1">
                {overrideCount} {t('productContent.channels.overrides')}
              </span>
            )}
          </>
        )}
      </div>
    </div>
  )
}
